export const serviceErrorMapper = ({ message }) => ({ ok: false, errorMessage: message });
